import React, { ChangeEvent } from 'react';
import { useEffect } from 'react';
import { useApiRequest } from '../../../utilities/api';
import { SUCCESS } from '../../../utilities/api/actionTypes';
import BranchDropdown from '../BranchDropdown';

export interface IBranchLoaderProps {
    onChange: (e: ChangeEvent) => void;
}

export default function BranchLoader(props: IBranchLoaderProps) {
    const [branchApi, getBranches] = useApiRequest(`${process.env.GATSBY_API_URL}/branches`);

    useEffect(() => {
        getBranches();
    }, []);

    return (
        <div>
            {branchApi.status === SUCCESS && <BranchDropdown onChange={props.onChange} branches={branchApi.response}></BranchDropdown>}
        </div>
    );
}
